import { css } from "@emotion/core";

import { color, fontSizes, fonts } from "../../theme/Theme";

export const homeStyles = css({
  ".greeting": {
    color: color.primary,
    fontSize: fontSizes.heading,
    fontFamily: fonts.bold
  },
  ".disabled-text": {
    color: color.placeholder
  },
  ".home-card-title": {
    fontSize: fontSizes.cardLabel,
    fontFamily: fonts.bold
  },
  ".ant-card": {
    borderRadius: "0.375rem",
    boxShadow: `0 0 0.25rem 0 ${color.boxShadowDark}`
  },
  ".ant-card-body": {
    padding: "1rem 1.5rem"
  },
  ".ant-divider-dashed": {
    borderColor: color.border,
    height: "100%"
  },
  ".ant-btn-link": {
    color: color.lightBlue
  },
  ".ant-btn-link[disabled]": {
    color: color.placeholder
  }
});
